// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"226ba5ed","453":"ce3284ba"}[chunkId] + ".chunk.js";
};